var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99967 0.166667C4.23301 0.166667 0.333008 4.06667 0.333008 8.83333C0.333008 13.9792 6.83301 20.2625 8.56634 21.6708C8.67467 21.7792 8.83717 21.8333 8.99967 21.8333C9.16217 21.8333 9.32467 21.7792 9.43301 21.6708C11.1663 20.2625 17.6663 13.9792 17.6663 8.83333C17.6663 4.06667 13.7663 0.166667 8.99967 0.166667ZM4.66634 8.83333C4.66634 6.45 6.61634 4.5 8.99967 4.5C11.383 4.5 13.333 6.45 13.333 8.83333C13.333 11.2167 11.383 13.1667 8.99967 13.1667C6.61634 13.1667 4.66634 11.2167 4.66634 8.83333ZM5.74967 8.83333C5.74967 10.6208 7.21217 12.0833 8.99967 12.0833C10.7872 12.0833 12.2497 10.6208 12.2497 8.83333C12.2497 7.04583 10.7872 5.58333 8.99967 5.58333C7.21217 5.58333 5.74967 7.04583 5.74967 8.83333ZM1.41634 8.83333C1.41634 13.3292 7.26634 19.2333 8.99967 20.6417C10.733 19.2333 16.583 13.3292 16.583 8.83333C16.583 4.6625 13.1705 1.25 8.99967 1.25C4.82884 1.25 1.41634 4.6625 1.41634 8.83333Z",
    fill: "#582483"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.28227d8ca4bc080c757de2a1746a3ca9.svg";
export { ForwardRef as ReactComponent };